import React from 'react'

import { useSelector } from 'react-redux'

import { IApplicationState } from '@store'
import { selectShowBrandedContentAdActions } from '@store/submissions'
import { Container } from '@tribegroup'
import BrandedContentAdBarButton from './Button'

interface IBrandedContentAdActions {
  submissionId: number
}

const BrandedContentAdBar: React.FC<IBrandedContentAdActions> = ({ submissionId }) => {
  const showBrandedContentAdActions = useSelector((state: IApplicationState) =>
    selectShowBrandedContentAdActions(state, submissionId),
  )

  return (
    <Container
      topInnerSpacing={1}
      bottomInnerSpacing={0.5}
      leftInnerSpacing={1}
      rightInnerSpacing={1}
      height={2}
    >
      {showBrandedContentAdActions && <BrandedContentAdBarButton submissionId={submissionId} />}
    </Container>
  )
}

export { BrandedContentAdBar }
export default BrandedContentAdBar
